"use client";

import { useEffect, useState } from "react";
import { ChevronUp } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import Image from "next/image";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { UserIcon } from "./icons";
import BuyCreditsModal from "./BuyCreditsModal";
import FeedbackForm from "./feedbackForm";
import { useTheme } from "next-themes";
import { useArtifact } from "@/hooks/use-artifact";
import { useRouter } from "next/navigation";
import { useSelector, useDispatch } from "react-redux";
import { setActiveItem } from "@/store/mainSlice";
import CompleteYourProfile from "./profile";
import ChangePasswordComp from "./changePassword";
import UpgradePlan from "./upgrade-plan";

export function SidebarUserNav({ className }) {
  const [showBuyCreditsModal, setShowBuyCreditsModal] = useState(false);
   const [showPlan, setShowPlan] = useState(false);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [profile, setProfile] = useState(false);
  const [changePassword, setChangePassword] = useState(false);

  const { user_ai_limit, userData, isGeneratingWebsite } = useSelector(
    (state) => state.main
  );
  useEffect(() => {
    if (userData.is_profile_complete == 0) {
      setProfile(true)
      dispatch(setActiveItem("z-[45]"));
    }
  }, [userData])
  

  const test = async () => {
    if (isGeneratingWebsite) {
      toast.error("Please hold on—we’re setting up your page.", {
        style: { color: "red" },
        position: "top-center",
        iconTheme: { primary: "red", secondary: "#fff" },
      });
      return;
    }

    // await axios.post(
    //   "https://site.varnz.ai/api/users/logout",
    //   {},
    //   { withCredentials: true }  // ✅ Cookie clear hone ke liye zaroori
    // );
    localStorage.clear()
    window.location.href = "/login";
    // router.push("/login")
  }
  // useEffect(() => {
  //   if (!userData?.email) {
  //     router.push("/login")
  //   }
  // })
  const dispatch = useDispatch();
  const { setTheme, resolvedTheme } = useTheme();
  const router = useRouter();
  return (
    <>
      <SidebarMenu className={`${className}`}>
        <SidebarMenuItem>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <SidebarMenuButton className="[.group_&]:p-0 md:[.group_&]:p-2 [.group_&]:h-12 md:[.group_&]:h-auto data-[state=open]:bg-sidebar-accent bg-background data-[state=open]:text-sidebar-accent-foreground h-12 flex items-center gap-3">
                <Image
                  // src={`https://avatar.vercel.sh/${userData?.email}`}  items-start
                  src={
                    userData?.image_path
                      ? userData.image_path.startsWith("http")
                        ? userData.image_path
                        : `${process.env.NEXT_PUBLIC_APP_URL_LOCAL}/${userData.image_path}`
                      : `https://avatar.vercel.sh/${userData?.email}`
                  }
                  alt={userData?.email ?? "User Avatar"}
                  width={32}
                  height={32}
                  className="rounded-full w-[24px] h-[24px]"
                />
                <div className="[.group_&]:hidden md:[.group_&]:flex flex flex-col group-data-[collapsible=icon]:hidden group-data-[collapsible=offcanvas]:hidden whitespace-nowrap max-w-[150px]">
                  <span className="text-sm font-medium text-foreground truncate">
                    {userData?.name ?? userData?.email}
                  </span>
                  <span className="text-xs text-muted-foreground">
                    Total Credit: {user_ai_limit ?? 0}
                  </span>
                </div>
              </SidebarMenuButton>
            </DropdownMenuTrigger>
            <DropdownMenuContent
              side="top"
              className="rounded-[12px] p-1.5 dark:bg-[#353535] left-[5px]!"
            >
              <div className="px-2 py-1 text-sm text-zinc-400 flex items-center gap-2 py-1.5 px-2.5 pr-8 text-xs leading-[2] hover:bg-[rgba(255,255,255,0.05)] rounded-[10px]">
                <UserIcon />
                {userData?.email ?? "No email"}
              </div>

              <DropdownMenuItem
                data-testid="user-nav-item-theme"
                className="cursor-pointer py-1.5 px-2.5 pr-8 text-xs leading-[2] hover:bg-[rgba(255,255,255,0.05)] rounded-[10px]"
                onSelect={() =>
                  setTheme(resolvedTheme === "dark" ? "light" : "dark")
                }
              >
                {`Toggle ${resolvedTheme === "light" ? "dark" : "light"} mode`}
              </DropdownMenuItem>

              <DropdownMenuItem
                className="cursor-pointer py-1.5 px-2.5 pr-8 text-xs leading-[2] hover:bg-[rgba(255,255,255,0.05)] rounded-[10px]"
                onSelect={() => {
                  dispatch(setActiveItem("z-[45]"));
                  setShowBuyCreditsModal(true);
                }}
              >
                Buy Credits
              </DropdownMenuItem>

              {/* <DropdownMenuItem
                className="cursor-pointer py-1.5 px-2.5 pr-8 text-xs leading-[2] hover:bg-[rgba(255,255,255,0.05)] rounded-[10px]"
                onSelect={() => {
                  dispatch(setActiveItem("z-[45]"));
                  setShowPlan(true);
                }}
              >
                Upgrade Plan
              </DropdownMenuItem> */}
              <DropdownMenuItem
                className="cursor-pointer py-1.5 px-2.5 pr-8 text-xs leading-[2] hover:bg-[rgba(255,255,255,0.05)] rounded-[10px]"
                onSelect={() => {
                  dispatch(setActiveItem("z-[45]"));
                  setShowFeedbackModal(true);
                }}
              >
                Share Feedback
              </DropdownMenuItem>
              <DropdownMenuItem
                className="cursor-pointer py-1.5 px-2.5 pr-8 text-xs leading-[2] hover:bg-[rgba(255,255,255,0.05)] rounded-[10px]"
                // onSelect={() => setShowFeedbackModal(true)}
                onSelect={() => {
                  setProfile(true);
                  dispatch(setActiveItem("z-[45]"));
                  // setShowFeedbackModal(true);
                }}
              >
                Profile
              </DropdownMenuItem>

              <DropdownMenuItem
                className="cursor-pointer py-1.5 px-2.5 pr-8 text-xs leading-[2] hover:bg-[rgba(255,255,255,0.05)] rounded-[10px]"
                // onSelect={() => setShowFeedbackModal(true)}
                onSelect={() => {
                  setChangePassword(true);
                  dispatch(setActiveItem("z-[45]"));
                  // setShowFeedbackModal(true);
                }}
              >
                Change Password
              </DropdownMenuItem>

              <DropdownMenuItem
                className="cursor-pointer py-1.5 px-2.5 pr-8 text-xs leading-[2] hover:bg-[rgba(255,255,255,0.05)] rounded-[10px]"
                onSelect={test}
              >
                Logout
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </SidebarMenuItem>
      </SidebarMenu>

      {showBuyCreditsModal && userData && (
        <BuyCreditsModal
          show={showBuyCreditsModal}
          handleClose={() => setShowBuyCreditsModal(false)}
          userDetail={userData}
        />
      )}

      {showFeedbackModal && (
        <FeedbackForm
          show={showFeedbackModal}
          handleClose={() => setShowFeedbackModal(false)}
        />
      )}

      {profile && (
        <CompleteYourProfile
          show={profile}
          handleClose={() => setProfile(false)}
        />
      )}

      {changePassword && (
        <ChangePasswordComp
          show={changePassword}
          handleClose={() => setChangePassword(false)}
        />
      )}
       {showPlan && userData && (
        <UpgradePlan
          show={showPlan}
          handleClose={() => setShowPlan(false)}
          userDetail={userData}
        />
      )}
    </>
  );
}
